module.exports = __webpack_public_path__ + "static/media/background.50b71e4a.mp4";